import React from 'react';
import {  Modal, Form } from 'react-bootstrap';


const ConfirmationWindow = ({showModal, setShowModal, body, title, handleOnClick}) => {
    
    return (
        <div className='flex-row-center'>
        <Modal show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ textAlign: 'justify'}}>{body}</Modal.Body>
            <Modal.Footer className='modal-footer flex-row-center'>
                <button className='btn-custom-flex blue' onClick={() => {
                    setShowModal(false);
                }}>No</button>
                <button className='btn-custom-flex green' onClick={() => {
                    handleOnClick();
                    setShowModal(false);
                }}>Yes</button>
            </Modal.Footer>
        </Modal>
    </div>
    )
}


export default ConfirmationWindow;
